
import { Options, Vue } from "vue-class-component";
import Navbar from "@/components/Navbar.vue";
import bootstrap from "bootstrap";
import {
  FlowForm,
  QuestionModel,
  QuestionType,
  ChoiceOption,
  LanguageModel,
  Question,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
} from "@ditdot-dev/vue-flow-form";
import { XCircleIcon } from "@heroicons/vue/outline";

@Options({
  components: {
    Navbar,
    FlowForm,
    QuestionModel,
    QuestionType,
    ChoiceOption,
    Question,
    XCircleIcon,
  },
  data() {
    return {
      language: new LanguageModel({
        skip: "Saltar",
        continue: "Siguiente",
        pressEnter: "Puedes presionar ENTER",
        otherPrompt: "Otro",
        submitText: "Enviar",
        thankYouText: "¡Gracias!",
        successText: "Tu opinión es muy importante para nosotros.",
      }),
      questions: [
        new QuestionModel({
          id: "design",
          tagline: "1 de 3",
          title:
            "¿El diseño de la página web le permitió buscar y consultar la información de manera fácil?",
          helpTextShow: false,
          type: QuestionType.MultipleChoice,
          multiple: false,
          allowOther: false,
          required: true,
          options: [
            new ChoiceOption({
              label: "Sí",
            }),
            new ChoiceOption({
              label: "No",
            }),
          ],
        }),
        new QuestionModel({
          id: "occupation",
          tagline: "2 de 3",
          title: "¿Cuál es su principal ocupación?",
          helpTextShow: false,
          type: QuestionType.MultipleChoice,
          multiple: false,
          allowOther: false,
          required: true,
          options: [
            new ChoiceOption({
              label: "Estudiante",
            }),
            new ChoiceOption({
              label: "Academia/Investigación",
            }),
            new ChoiceOption({
              label: "Trabajador(a) sector público",
            }),
            new ChoiceOption({
              label: "Trabajador(a) sector privado",
            }),
            new ChoiceOption({
              label: "Desempleado(a)",
            }),
            new ChoiceOption({
              label: "Otro",
            }),
          ],
        }),
        new QuestionModel({
          id: "goal",
          tagline: "3 de 3",
          title:
            "¿Con qué fines consultó o descargó la información del portal?",
          helpTextShow: false,
          type: QuestionType.MultipleChoice,
          multiple: false,
          allowOther: false,
          required: true,
          options: [
            new ChoiceOption({
              label: "Por interés general",
            }),
            new ChoiceOption({
              label: "Para alguna investigación",
            }),
            new ChoiceOption({
              label: "Por capacitación/educación",
            }),
            new ChoiceOption({
              label: "Otro",
            }),
          ],
        }),
      ],
    };
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    async onComplete(completed, questionList) {
      //console.log("completed", completed);
      //console.log("questionList", questionList);
      this.completed = completed;
      this.$refs.flowform.submitted = true;

      const payload = {};
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const questions = [];

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      questionList.forEach(q => {
        const obj = {};
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        obj.id = q.id;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        obj.title = q.title;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        obj.type = q.type;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        obj.answer = q.answer;
        questions.push(obj);
      });

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      payload.questions = questions;

      let now = new Date().toISOString();

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      payload.created = now;

      const data = await this.$store.dispatch("submitPollAnswer", payload);
    },
    openModal() {
      var myModalEl = this.$el.querySelector("#myModal");
      //console.log(myModalEl);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var modal = bootstrap.Modal.getOrCreateInstance(myModalEl);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      modal.show();
    },
  },
})
export default class Header extends Vue {}
